import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const NAV = [
  { to: '/',          icon: '◎', label: 'Inicio',    exact: true },
  { to: '/posts',     icon: '◫', label: 'Posts' },
  { to: '/publish',   icon: '⚡', label: 'Publicar',  highlight: true },
  { to: '/calendar',  icon: '📅', label: 'Agenda' },
  { to: '/analytics', icon: '◈', label: 'Stats' },
];

export default function BottomNav() {
  const navigate = useNavigate();

  return (
    <nav className="bottom-nav" style={{ display: 'none' }}>
      {NAV.map(item => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.exact}
          style={({ isActive }) => ({
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '3px',
            textDecoration: 'none',
            fontSize: '10px',
            fontWeight: '600',
            color: isActive
              ? (item.highlight ? '#a78bfa' : 'var(--text-primary)')
              : 'var(--text-muted)',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '6px 0',
            transition: 'color 0.15s',
            position: 'relative',
          })}
        >
          {({ isActive }) => (
            <>
              <span style={{
                fontSize: '20px',
                lineHeight: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '36px',
                height: '28px',
                borderRadius: '12px',
                background: isActive
                  ? (item.highlight ? 'var(--gradient-primary)' : 'var(--bg-hover)')
                  : item.highlight ? 'var(--gradient-glow)' : 'transparent',
                transition: 'background 0.15s',
              }}>
                {item.icon}
              </span>
              <span style={{
                fontSize: '10px',
                color: isActive
                  ? (item.highlight ? '#a78bfa' : 'var(--text-primary)')
                  : 'var(--text-muted)',
              }}>
                {item.label}
              </span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
